export default "__VITE_ASSET__Cyb62Csk__"